<div class="flex flex-col gap-12">
  <div class="flex items-center justify-between">
    <app-title>{{ 'page.tags.title' | translate }}</app-title>
    <app-button text="{{ 'page.tags.add' | translate }}" icon="/assets/images/icon-add.svg" (click)="createTag()"></app-button>
  </div>

  <app-tabs>
    <app-tab text="{{ 'page.tags.list' | translate }}" link="/panel/tags/list"></app-tab>
  </app-tabs>

  <div>
    <router-outlet></router-outlet>
  </div>
</div>
